export const GROUP_ICON_MAPPING = {
	GROUP: [
		{
			name: 'CLIENT',
			icon: 'fas fa-hands-helping',
		},
		{
			name: 'COMPANY',
			icon: 'fas fa-id-card',
		},
		{
			name: 'CONTRACTOR',
			icon: 'fas fa-hard-hat',
		},
		{
			name: 'SUPPLIER',
			icon: 'fas fa-store',
		},
	],
};
